/* ==========================================================
   Product Details section controller
   Save as: assets/product-details.js
   Depends on window.__pdpProductData / __pdpCartUrl
   (both injected inline by sections/product-details.liquid)
   ========================================================== */

(function () {
  "use strict";

  document.addEventListener("DOMContentLoaded", init);

  function init() {
    var root = document.querySelector("[data-product-details]");
    if (!root) return;

    var product = window.__pdpProductData;
    var cartUrls = window.__pdpCartUrl;
    if (!product || !cartUrls) return;

    // ---------- State ----------
    var state = {
      variant: product.selected_or_first_available_variant || product.variants[0],
      multibuyQty: 1,
      multibuyDiscountPct: 0,
      manualQty: 1
    };

    // ---------- Elements ----------
    var els = {
      price: root.querySelector("[data-price]"),
      unitPrice: root.querySelector("[data-unit-price]"),
      stockLabel: root.querySelector("[data-stock-label]"),
      packGroup: root.querySelector("[data-pack-size-group]"),
      multibuyGroup: root.querySelector("[data-multibuy-group]"),
      qtyInput: root.querySelector("[data-qty-input]"),
      qtyDecrease: root.querySelector("[data-qty-decrease]"),
      qtyIncrease: root.querySelector("[data-qty-increase]"),
      addBtn: root.querySelector("[data-add-to-cart]"),
      addBtnLabel: root.querySelector("[data-add-btn-label]"),
      addBtnPrice: root.querySelector("[data-add-btn-price]"),
      formError: root.querySelector("[data-form-error]"),
      formSuccess: root.querySelector("[data-form-success]"),
      shippingBar: root.querySelector("[data-shipping-bar]"),
      shippingRemaining: root.querySelector("[data-shipping-remaining]"),
      shippingTotal: root.querySelector("[data-shipping-total]"),
      shippingFill: root.querySelector("[data-shipping-fill]"),
      shippingMessage: root.querySelector("[data-shipping-message]"),
      clearpayAmount: root.querySelector("[data-clearpay-amount]"),
      thumbs: root.querySelectorAll("[data-thumb]"),
      mainImage: document.getElementById("PdpMainImage")
    };

    var freeShippingThreshold = parseInt(
      (els.shippingBar && els.shippingBar.dataset.threshold) || "0",
      10
    ); // cents

    // ---------- Helpers ----------
    function formatMoney(cents) {
      // Lightweight formatter; swap for Shopify.formatMoney if theme includes money.js
      if (window.Shopify && typeof window.Shopify.formatMoney === "function" && window.__pdpMoneyFormat) {
        return window.Shopify.formatMoney(cents, window.__pdpMoneyFormat);
      }
      return "£" + (cents / 100).toFixed(2);
    }

    function findVariantById(id) {
      for (var i = 0; i < product.variants.length; i++) {
        if (String(product.variants[i].id) === String(id)) return product.variants[i];
      }
      return null;
    }

    function packSizeNumber(variant) {
      // Pulls the leading integer out of the pack-size option value, e.g. "30 tablets" -> 30
      var optionIndex = els.packGroup ? parseInt(els.packGroup.dataset.optionIndex, 10) : -1;
      if (optionIndex < 0 || !variant) return null;
      var raw = variant.options[optionIndex] || "";
      var match = raw.match(/\d+/);
      return match ? parseInt(match[0], 10) : null;
    }

    function effectiveUnitPricePerItem() {
      // price after multi-buy discount, in cents, for a single pack
      var base = state.variant.price;
      var discounted = base - Math.round((base * state.multibuyDiscountPct) / 100);
      return discounted;
    }

    function totalLinePrice() {
      return effectiveUnitPricePerItem() * state.manualQty;
    }

    // ---------- Render ----------
    function renderPrice() {
      els.price.textContent = formatMoney(state.variant.price);

      var packSize = packSizeNumber(state.variant);
      if (packSize) {
        var perTablet = Math.round(state.variant.price / packSize);
        els.unitPrice.textContent = formatMoney(perTablet) + " per tablet";
      } else {
        els.unitPrice.textContent = "";
      }

      els.stockLabel.textContent = state.variant.available ? "In stock" : "Out of stock";
      els.stockLabel.classList.toggle("is-out", !state.variant.available);

      els.addBtn.disabled = !state.variant.available;
      els.addBtnLabel.textContent = state.variant.available ? "Add to basket" : "Sold out";
      els.addBtnPrice.textContent = state.variant.available
        ? "— " + formatMoney(totalLinePrice())
        : "";

      // Clearpay: 4 interest-free installments of the line total
      var installment = Math.round(totalLinePrice() / 4);
      if (els.clearpayAmount) els.clearpayAmount.textContent = formatMoney(installment);
    }

    function renderMultibuySubtext() {
      var pills = els.multibuyGroup.querySelectorAll("[data-multibuy-pill]");
      pills.forEach(function (pill) {
        var qty = parseInt(pill.dataset.qty, 10);
        var pct = parseInt(pill.dataset.discountPct, 10);
        var sub = pill.querySelector("[data-multibuy-sub]");
        var full = state.variant.price * qty;
        var discounted = full - Math.round((full * pct) / 100);
        if (pct > 0) {
          sub.textContent =
            formatMoney(discounted) + " · save " + formatMoney(full - discounted);
        } else {
          sub.textContent = formatMoney(discounted);
        }
      });
    }

    function renderShippingBar(cartTotalCents) {
      if (!els.shippingBar || !freeShippingThreshold) return;
      var projected = cartTotalCents + totalLinePrice(); // what cart would be if this item is added
      var remaining = freeShippingThreshold - projected;

      if (remaining <= 0) {
        els.shippingMessage.textContent = "You've unlocked free delivery! 🎉";
        els.shippingFill.style.width = "100%";
      } else {
        els.shippingRemaining.textContent = formatMoney(remaining);
        els.shippingMessage.innerHTML =
          "Add <strong data-shipping-remaining>" +
          formatMoney(remaining) +
          "</strong> more for free delivery";
        var pct = Math.min(100, Math.round((projected / freeShippingThreshold) * 100));
        els.shippingFill.style.width = pct + "%";
      }
      els.shippingTotal.textContent =
        formatMoney(Math.min(projected, freeShippingThreshold)) +
        " / " +
        formatMoney(freeShippingThreshold);
    }

    function fetchCartAndRenderShipping() {
      fetch(cartUrls.cart)
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          renderShippingBar(cart.total_price || 0);
        })
        .catch(function () {
          renderShippingBar(0);
        });
    }

    function renderAll() {
      renderPrice();
      renderMultibuySubtext();
      fetchCartAndRenderShipping();
    }

    // ---------- Event wiring: Pack size ----------
    if (els.packGroup) {
      els.packGroup.addEventListener("click", function (e) {
        var pill = e.target.closest("[data-pack-pill]");
        if (!pill || pill.disabled) return;

        var variant = findVariantById(pill.dataset.variantId);
        if (!variant) return;

        state.variant = variant;

        els.packGroup.querySelectorAll("[data-pack-pill]").forEach(function (p) {
          p.classList.toggle("is-active", p === pill);
        });

        renderAll();
      });
    }

    // ---------- Event wiring: Multi-buy tiers ----------
    if (els.multibuyGroup) {
      els.multibuyGroup.addEventListener("click", function (e) {
        var pill = e.target.closest("[data-multibuy-pill]");
        if (!pill) return;

        state.multibuyQty = parseInt(pill.dataset.qty, 10);
        state.multibuyDiscountPct = parseInt(pill.dataset.discountPct, 10);
        state.manualQty = state.multibuyQty;
        els.qtyInput.value = state.manualQty;

        els.multibuyGroup.querySelectorAll("[data-multibuy-pill]").forEach(function (p) {
          p.classList.toggle("is-active", p === pill);
        });

        renderAll();
      });
    }

    // ---------- Event wiring: Quantity stepper ----------
    function clampQty(val) {
      var n = parseInt(val, 10);
      if (isNaN(n) || n < 1) n = 1;
      return n;
    }

    els.qtyDecrease.addEventListener("click", function () {
      state.manualQty = clampQty(state.manualQty - 1);
      els.qtyInput.value = state.manualQty;
      syncMultibuySelectionToManualQty();
      renderAll();
    });

    els.qtyIncrease.addEventListener("click", function () {
      state.manualQty = clampQty(state.manualQty + 1);
      els.qtyInput.value = state.manualQty;
      syncMultibuySelectionToManualQty();
      renderAll();
    });

    els.qtyInput.addEventListener("change", function () {
      state.manualQty = clampQty(els.qtyInput.value);
      els.qtyInput.value = state.manualQty;
      syncMultibuySelectionToManualQty();
      renderAll();
    });

    function syncMultibuySelectionToManualQty() {
      // If the manual qty no longer matches a tier, drop the discount
      // and clear the active state (unless it exactly matches a tier).
      var pills = els.multibuyGroup ? els.multibuyGroup.querySelectorAll("[data-multibuy-pill]") : [];
      var matched = null;
      pills.forEach(function (pill) {
        var qty = parseInt(pill.dataset.qty, 10);
        if (qty === state.manualQty) matched = pill;
      });

      pills.forEach(function (p) {
        p.classList.toggle("is-active", p === matched);
      });

      state.multibuyDiscountPct = matched ? parseInt(matched.dataset.discountPct, 10) : 0;
    }

    // ---------- Event wiring: Thumbnails ----------
    els.thumbs.forEach(function (thumb) {
      thumb.addEventListener("click", function () {
        if (!els.mainImage) return;
        els.mainImage.src = thumb.dataset.full;
        els.thumbs.forEach(function (t) {
          t.classList.toggle("is-active", t === thumb);
        });
      });
    });

    // ---------- Add to cart ----------
    els.addBtn.addEventListener("click", function () {
      if (els.addBtn.disabled) return;

      hideMessages();
      els.addBtn.classList.add("is-loading");

      fetch(cartUrls.add, {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({
          items: [
            {
              id: state.variant.id,
              quantity: state.manualQty,
              properties:
                state.multibuyDiscountPct > 0
                  ? { "Multi-buy tier": state.multibuyQty + " packs" }
                  : {}
            }
          ]
        })
      })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || "Could not add item to cart");
            });
          }
          return res.json();
        })
        .then(function () {
          showSuccess();
          fetchCartAndRenderShipping();
          document.dispatchEvent(
            new CustomEvent("cart:updated", { bubbles: true, detail: { variantId: state.variant.id } })
          );
          bumpCartCountBadgeIfPresent();
        })
        .catch(function (err) {
          showError(err.message || "Something went wrong. Please try again.");
        })
        .finally(function () {
          els.addBtn.classList.remove("is-loading");
        });
    });

    function hideMessages() {
      els.formError.hidden = true;
      els.formSuccess.hidden = true;
    }
    function showError(msg) {
      els.formError.textContent = msg;
      els.formError.hidden = false;
    }
    function showSuccess() {
      els.formSuccess.hidden = false;
      setTimeout(function () {
        els.formSuccess.hidden = true;
      }, 4000);
    }

    function bumpCartCountBadgeIfPresent() {
      // Best-effort update for common theme cart-count elements.
      // Safe no-op if the theme uses something custom.
      fetch(cartUrls.cart)
        .then(function (r) {
          return r.json();
        })
        .then(function (cart) {
          document
            .querySelectorAll("[data-cart-count], .cart-count-bubble, #CartCount")
            .forEach(function (el) {
              el.textContent = cart.item_count;
            });
        })
        .catch(function () {});
    }

    // ---------- Initial render ----------
    renderAll();
  }
})();
